import { Logo } from '@/components/onboarding/logo'

interface HeaderProps {
  className?: string
  children?: React.ReactNode
  showLogo?: boolean
  rightContent?: React.ReactNode
}

export function Header({ className, children, showLogo = true, rightContent }: HeaderProps) {
  return (
    <header className={`bg-white ${className ?? ''}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-4">
            {showLogo && <Logo size="md" />}
            {children}
          </div>
          {rightContent && <div className="flex items-center gap-4">{rightContent}</div>}
        </div>
      </div>
    </header>
  )
}
